import React from 'react'
import PropTypes from 'prop-types'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
//import withScriptjs from 'react-google-maps/lib/async/withScriptjs'
import SearchBox from "react-google-maps/lib/places/SearchBox";
import { compose } from 'recompose'
import axios from 'axios'
import { connect } from 'react-redux'
import { UpdateGEOAddress } from '../actions'
// FIXME: review render on recompose >> can use recompose

const Map = (props) => {
    const {
    onMapLoad,
        onMapClick,
        markers,
        defaultCenter,
        zoom,
        markerIcon,
        onPositionChanged,
        getPosition,
        setlocation,
        center,
        setcentermap,
        refs
  } = props

    return (
        <GoogleMap
            ref={onMapLoad}
            zoom={zoom}
            defaultCenter={defaultCenter}
            onClick={onMapClick}
            setlocation={setlocation}
            center={center}
            setcentermap={setcentermap}
            disableDefaultUI={true}
            streetViewControl={false}
        >
            {/* <SearchBox
                controlPosition={google.maps.ControlPosition.TOP_LEFT}
                inputPlaceholder="ป้อนสถานที่ที่ต้องการค้นหา"
                inputStyle={{
                    boxSizing: `border-box`,
                    border: `1px solid transparent`,
                    width: `240px`,
                    height: `32px`,
                    marginTop: `10px`,
                    padding: `0 12px`,
                    borderRadius: `3px`,
                    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                    fontSize: `14px`,
                    outline: `none`,
                    textOverflow: `ellipses`,
                }}
                //ref={SearchBox}
                //ref={(input) => { this.inputtext = input; console.log(input) }}
                //onSearchBoxMounted={onSearchBoxMounted}
                getPlaces={(e)=>{console.log(e)}}
                bounds={props.bounds}
                controlPosition={google.maps.ControlPosition.TOP_LEFT}
                onPlacesChanged={props.onPlacesChanged}
            /> */}
            {markers.map((marker, index) => (
                <Marker
                    key={index}
                    onDragEnd={(e) => {
                        //getPosition(e)
                        setlocation(e.latLng.lat(), e.latLng.lng())
                        setcentermap(e.latLng.lat(),e.latLng.lng())
                    }}
                    {...marker}
                />
            ))}
        </GoogleMap>
    )

}

Map.propTypes = {
    onMapLoad: PropTypes.func,
    onMapClick: PropTypes.func,
    markers: PropTypes.array,
    defaultCenter: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
    }),
    zoom: PropTypes.number,
}

Map.defaultProps = {
    // onSearchBoxMounted: ref => {
    //     refs.searchBox = ref;
    //     console.log("TEXT",refs.searchBox)
    // },
    // onPlacesChanged: (refs) => {
    //     console.log("CALLED")
    //     console.log(refs)
    //     const places = refs.SearchBox.getPlaces();
    //     const bounds = new google.maps.LatLngBounds();

    //     places.forEach(place => {
    //         if (place.geometry.viewport) {
    //             bounds.union(place.geometry.viewport)
    //         } else {
    //             bounds.extend(place.geometry.location)
    //         }
    //     });
    //     const nextMarkers = places.map(place => ({
    //         position: place.geometry.location,
    //     }));
    //     const nextCenter = _.get(nextMarkers, '0.position', this.state.center);
    //     console.log(nextCenter, nextMarkers)
    //     this.setState({
    //         center: nextCenter,
    //         markers: nextMarkers,
    //     });
    //     // refs.map.fitBounds(bounds);
    // },
    onMapLoad: (map) => {
        this._mapComponent = map;
        if (map) {
        }
    },
    onMapClick: (event) => {
        const nextMarkers = [
            ...this.state.markers,
            {
                position: event.latLng,
                defaultAnimation: 2,
                key: Date.now(), // Add a key property for: http://fb.me/react-warning-keys
            },
        ];
        this.setState({
            markers: nextMarkers,
        });
    },
    markers: [],
    defaultCenter: {
        lat: 0,
        lng: 0,
    },
    zoom: 12,
    getPosition: (e) => {

    }

}

export default compose(withGoogleMap)(connect()(Map))


// WEBPACK FOOTER //
// ./src/components/map.js